import trackMetrics from './metrics';
import getEnvelope from './envelope';
import constructData from './constructData';
import sendData from './sendData';
import WeapiEventPayload from './contracts/weapiEventPayload';
import { prodUrl, devUrl, testUrl } from './constants';

const getDataFromMetrics = (name, value, unit, payloadMetaAttributes) => {
  return {
    customAttributes: {
      name,
      value,
      unit,
      ...payloadMetaAttributes,
    },
  };
};

type TrackPerformanceParams = {
  environment: string;
  project: string;
  track: string;
  customEventName?: string;
  payloadMetaAttributes?: object;
  correlationId?: string;
};

const ANALYTICS_ENDPOINT = {
  production: prodUrl,
  prod: prodUrl,
  development: devUrl,
  dev: devUrl,
  test: testUrl,
};

// Prevent function from being called more than once per session.
let trackPerformanceExecuted = false;

const trackPerformance = ({
  environment,
  project,
  track,
  customEventName = '',
  payloadMetaAttributes = {},
  correlationId = '',
}: TrackPerformanceParams) => {
  if (trackPerformanceExecuted) {
    console.log(
      'trackPerformance() already called. This method should only be called once.',
    );
    return null;
  }
  trackPerformanceExecuted = true;
  if (!environment || !project || !track) {
    throw Error(
      'params environment, project, and track are required for trackPerformance()',
    );
  }
  const endpoint = ANALYTICS_ENDPOINT[environment] || ANALYTICS_ENDPOINT.dev;
  const eventName = customEventName || 'performance';
  const trackData = async data => {
    const { customAttributes = {} } = data || {};
    const { name: webVitalEventName } = customAttributes;
    const envelope = await getEnvelope(
      environment,
      project,
      track,
      eventName,
      correlationId,
    );
    const fullData: WeapiEventPayload = constructData(
      envelope,
      customAttributes,
    );
    // Add eventName as a query param so it's easier to find in Chrome dev tools.
    sendData(`${endpoint}?${webVitalEventName}`, fullData);
  };

  if (typeof window !== 'undefined') {
    trackMetrics((name, value, unit) =>
      trackData(getDataFromMetrics(name, value, unit, payloadMetaAttributes)),
    );
  }
};

export default trackPerformance;
